var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "msp-next-outage" }, [
    _c(
      "div",
      { staticClass: "msp-next-outage__title" },
      [
        _c("pui-headline", { attrs: { type: "h4" } }, [
          _vm._v(" " + _vm._s(_vm.$t("nextOutage")) + " "),
        ]),
      ],
      1
    ),
    _vm.hasOutageData
      ? _c("div", [
          _c(
            "div",
            { staticClass: "msp-next-outage__count_down_clock" },
            [
              _c("count-down-clock", {
                attrs: {
                  "radial-section-data": _vm.getRadialData(
                    _vm.nextOutageData.milestoneCompletionPercent
                  ),
                  "pie-section-data": _vm.getChartData(
                    new Date(_vm.nextOutageData.startDate),
                    new Date(_vm.nextOutageData.endDate)
                  ),
                  width: 200,
                  height: 200,
                  "component-id": "outageclock_" + _vm.unit.sid,
                  "active-phase": _vm.currentPhase,
                  "active-phase-progress-value":
                    _vm.getCurrentPhaseCompletedPercentage(
                      _vm.nextOutageData.startDate,
                      _vm.nextOutageData.endDate
                    ),
                  "active-phase-status": "Current",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "msp-next-outage__data" }, [
            _c("div", { staticClass: "msp-next-outage__data__group" }, [
              _c("div", { staticClass: "msp-next-outage__data__group__name" }, [
                _vm._v(
                  " " + _vm._s(_vm.nextOutageData.outageDescription) + " "
                ),
              ]),
              _c(
                "div",
                { staticClass: "msp-next-outage__data__group__leading" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("leadingItem") + ": ") + " "),
                  _vm.nextOutageData.leadingItemsDescription.length
                    ? _c("span", [_vm._v(" " + _vm._s(_vm.leadingItem) + " ")])
                    : _c("span", [
                        _vm._v(" " + _vm._s(_vm.$t("notDefined")) + " "),
                      ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "msp-next-outage__data__group__milestone-score",
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("milestoneScore") + ": ") + " "),
                  _c("span", [
                    _c("span", {
                      staticClass:
                        "msp-next-outage__data__group__milestone-score__dot",
                      style: _vm.dotColor,
                    }),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.nextOutageData.milestoneCompletionPercent) +
                          "%"
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm.currentPhase
                ? _c(
                    "div",
                    {
                      staticClass:
                        "msp-next-outage__data__group__current-phase",
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("currentPhase") + ": ") + " "),
                      _c("span", [
                        _c("span", {
                          staticClass:
                            "msp-next-outage__data__group__current-phase__dot",
                          class: _vm.color,
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.currentPhaseName))]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "msp-next-outage__data__group__detail" },
                [
                  _vm._v(" " + _vm._s(_vm.outageInfoText + ": ") + " "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.noDaysUntilOutage + " " + _vm.$t("days"))
                    ),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "msp-next-outage__data__group" }, [
              _c(
                "div",
                {
                  staticClass:
                    "msp-next-outage__data__group__duration msp-next-outage__data__group__detail",
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("plannedStart") + ": ") + " "),
                  _c("span", [_vm._v(_vm._s(_vm.startDate))]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "msp-next-outage__data__group__duration msp-next-outage__data__group__detail",
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("plannedEndDate") + ": ") + " "),
                  _c("span", [_vm._v(_vm._s(_vm.endDate))]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "msp-next-outage__data__group__duration msp-next-outage__data__group__detail",
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("plannedDuration") + ": ") + " "),
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.outageDuration) +
                        " " +
                        _vm._s(_vm.$t("days")) +
                        " "
                    ),
                  ]),
                ]
              ),
              _vm.nextOutageData.budgetValue
                ? _c(
                    "div",
                    { staticClass: "msp-next-outage__data__group__detail" },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("budgetValue") + ": ") + " "),
                      _c("span", [
                        _vm._v(
                          " " + _vm._s(_vm.nextOutageData.budgetValue) + " "
                        ),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s("k" + _vm.currencySymbol),
                          },
                        }),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.commercialValue
                ? _c(
                    "div",
                    { staticClass: "msp-next-outage__data__group__detail" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("oeCommercialValue") + ": ") + " "
                      ),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.commercialValue) + " "),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm.nextOutageData.extensionRisk
              ? _c(
                  "div",
                  { staticClass: "msp-next-outage__data__group__detail" },
                  [
                    _vm._v(" " + _vm._s(_vm.$t("extensionsRisk") + ": ") + " "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.nextOutageData.extensionRisk) + "%"),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.extensionCostValue
              ? _c(
                  "div",
                  { staticClass: "msp-next-outage__data__group__detail" },
                  [
                    _vm._v(" " + _vm._s(_vm.$t("extensionCosts") + ": ") + " "),
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.extensionCostValue) + " "),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _c(
          "div",
          [
            _c("pui-loader-error", {
              attrs: {
                title: _vm.$t("dataEmpty"),
                message: _vm.$t("noOutagePlanned"),
                icon: "error-empty-data",
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }